import { useTranslation } from "react-i18next";
import NavBar from "../components/NavBar";
import BackgroundImage from "../components/BackgroundImage";
import { Link } from "react-router-dom";
import { trackCTA } from "../utils/eventTracker";
import { projects } from "../constants/portfolio";
import Footer from "../components/Footer";

export default function Portfolio() {
  const { t } = useTranslation();
  const portfolioProjects = [
    {
      title: "cloudClipboardTitle",
      description: "cloudClipboardDescriptionShort",
      image: "/projects/cloud-clipboard.svg",
      imageClass: "cloud-clipboard-card",
      href: "/cloud-clipboard/",
    },
    ...projects,
  ];

  return (
    <>
      <div className="page-wrapper">
        <BackgroundImage />
        <NavBar />
        <div className="transparency-wrapper">
          <div className="secondary-page-wrapper">
            <div className="section-text-centered-wrapper-quote breathe">
              <div className="section-title-centered neon-glow">
                {t("aboutTitle1")}
              </div>
              <div className="section-subtitle-centered cyan">
                {t("portFolioTitle")}
              </div>
            </div>

            <div className="section-text-secondary-about-me">
              <p>{t("portfolioIntroParagraph")}</p>
            </div>

            <div className="cta-button-secondary-wrapper">
              <Link
                to="/quote"
                className="cta-button-secondary"
                onClick={() => trackCTA("portfolio-cta-1")}
              >
                {t("aboutCTA1")}
              </Link>
            </div>

            {portfolioProjects.map((project, index) => {
              const row = (
                <div
                  className={`portfolio-row ${
                    index % 2 === 0 ? "reverse" : ""
                  }`}
                >
                  <div className="portfolio-logo">
                    <img
                      src={project.image}
                      alt={project.title}
                      className={`portfolio-logo-image ${project.imageClass || ""}`.trim()}
                    />
                  </div>
                  <div className="portfolio-description-block">
                    <h3 className="portfolio-project-title">
                      {t(project.title)}
                    </h3>
                    <p className="portfolio-project-description">
                      {t(project.description)}
                    </p>
                  </div>
                </div>
              );

              if (project.href) {
                return (
                  <a
                    href={project.href}
                    key={project.title}
                    className="portfolio-row-link"
                  >
                    {row}
                  </a>
                );
              }

              return (
                <Link
                  to={project.route}
                  key={project.title}
                  className="portfolio-row-link"
                >
                  {row}
                </Link>
              );
            })}

            <div className="cta-button-secondary-wrapper">
              <Link
                to="/quote"
                className="cta-button-secondary"
                onClick={() => trackCTA("about-cta-bottom")}
              >
                {t("aboutCTA2")}
              </Link>
            </div>
            <div className="bottom-space"></div>
          </div>
          <Footer />
        </div>
      </div>
    </>
  );
}
